import { Layout, IntersectionState as IntersectionStateComponent } from "components"
export const IntersectionState = () => {
 return (
  <Layout>
   <IntersectionStateComponent />
  </Layout>
 )
}
